import CsDynamicTable from './CsDynamicTable.vue'
CsDynamicTable.install = function (Vue) {
  Vue.component(CsDynamicTable.name, CsDynamicTable)
}

import CsAlarmTable from './CsAlarmTable.vue'
CsAlarmTable.install = function (Vue) {
  Vue.component(CsAlarmTable.name, CsAlarmTable)
}

import DgPorTable from './DgPorTable.vue'
DgPorTable.install = function (Vue) {
  Vue.component(DgPorTable.name, DgPorTable)
}

export default [CsDynamicTable,CsAlarmTable,DgPorTable]



// WEBPACK FOOTER //
// ./src/components/dynamicTable/index.js